import React from 'react';
import { motion } from 'framer-motion';
import { Watermark } from './Watermark';
import { LayoutGrid, Briefcase, ShieldCheck, Sparkles, Clock, MapPin } from 'lucide-react';
const benefits = [{
  icon: <LayoutGrid className="w-6 h-6" data-id="element-46" data-mp="4je1zs5yj54p" />,
  title: 'Todo organizado en un solo lugar'
}, {
  icon: <Briefcase className="w-6 h-6" data-id="element-47" data-mp="3vpp9o75h3450" />,
  title: 'Fácil de transportar'
}, {
  icon: <ShieldCheck className="w-6 h-6" data-id="element-48" data-mp="3qrw33d09c847" />,
  title: 'Materiales resistentes'
}, {
  icon: <Sparkles className="w-6 h-6" data-id="element-49" data-mp="3mpixqppfac7y" />,
  title: 'Diseño hermoso y premium'
}, {
  icon: <Clock className="w-6 h-6" data-id="element-50" data-mp="3hqpml3xlyxay" />,
  title: 'Ahorra tiempo al trabajar'
}, {
  icon: <MapPin className="w-6 h-6" data-id="element-51" data-mp="3crutn95xfsd4" />,
  title: 'Perfecto para citas a domicilio o estudio'
}];
export function Benefits() {
  return <section className="relative overflow-hidden py-24 px-6 bg-white" data-id="element-52" data-mp="1fyjibyz0h26s">
      <Watermark position="left" align="top" size={700} opacity={0.05} data-id="element-53" data-mp="1azzuft0uxgbs" />
      <div className="relative z-10 max-w-6xl mx-auto" data-id="element-54" data-mp="1ayoslyqz2inb">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-55" data-mp="2qepfgld9e75">
          <h2 className="text-3xl md:text-4xl font-serif text-luxury-black mb-4" data-id="element-56" data-mp="lhpb9jc8j0s6">
            ¿POR QUÉ LO AMARÁS?
          </h2>
          <div className="w-16 h-0.5 bg-gold mx-auto" data-id="element-57" data-mp="qh2029mo2hxe"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-58" data-mp="bs5qu98viyv7">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-nude-light p-8 rounded-xl border border-nude hover:border-gold/30 transition-colors duration-300 flex flex-col items-center text-center group" data-id="element-59" data-mp="gpxl39wzqx2k" data-mpi={index}>
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center text-gold mb-6 shadow-sm group-hover:scale-110 transition-transform duration-300" data-id="element-60" data-mp="152plrz8ipuid">
                {benefit.icon}
              </div>
              <h3 className="text-lg font-sans font-medium text-luxury-black" data-id="element-61" data-mp="vbl770mr8bo2">
                {benefit.title}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}